if ($('.property-detail').length) {
    const $slideshow = $('.property-detail .slideshow .items');
    const numItems = $slideshow.children().length;

    $slideshow.slick({
        cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
        useCSS: true,
        useTransform: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
    });

    const $actions = $('.property-detail .slideshow .actions');
    $actions.find('.prev').on('click', () => $slideshow.slick('slickPrev'));
    $actions.find('.next').on('click', () => $slideshow.slick('slickNext'));

    const $counter = $actions.find('.counter');
    const updateCounter = () => $counter.text(`${$slideshow.slick('slickCurrentSlide')+1}/${numItems}`);
    $slideshow.on('afterChange', updateCounter);
    updateCounter();

    const $map = $('.property-detail .slideshow .map-container');
    const $mapButton = $actions.find('.map');
    const $otherButtons = $actions.find(':not(.map)');
    let googleMap;
    $mapButton.on('click', () => {
        if ($map.is(':visible')) {
            $map.hide();
            $mapButton.removeClass('active');
            $slideshow.show();
            $otherButtons.prop('disabled', false).removeClass('disabled');
        } else {
            $map.show().css('height', $slideshow.height());
            $mapButton.addClass('active');
            $slideshow.hide().slick('slickPause');
            $otherButtons.prop('disabled', true).addClass('disabled');

            if (!googleMap) {
                const position = {lat: parseFloat($map.attr('data-lat')), lng: parseFloat($map.attr('data-long'))};
                googleMap = new google.maps.Map($map[0], {
                    center: position,
                    zoom: 16,
                });
                const marker = new google.maps.Marker({
                    position: position,
                    map: googleMap,
                });
            }
        }
    })
}



// WEBPACK FOOTER //
// ./scripts/properties.js